// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/proposal_compliance.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
/**
 * Authoring progress and explicit human substantive coverage are independent.
 *
 * @generated from message mono.datagateway.v1.ComplianceResponseLocation
 */ export class ComplianceResponseLocation extends Message {
    static fromBinary(bytes, options) {
        return new ComplianceResponseLocation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ComplianceResponseLocation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ComplianceResponseLocation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ComplianceResponseLocation, a, b);
    }
    constructor(data){
        super(), /**
   * volume, section, workbook (sheet), attachment; id is project-local.
   *
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * Section/page/cell or other precise response locator.
   *
   * @generated from field: string locator = 3;
   */ _define_property(this, "locator", ""), /**
   * @generated from field: repeated string accountable_user_ids = 4;
   */ _define_property(this, "accountableUserIds", []), /**
   * @generated from field: bool draft_complete = 5;
   */ _define_property(this, "draftComplete", false), /**
   * @generated from field: string evidence = 6;
   */ _define_property(this, "evidence", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ComplianceResponseLocation, "runtime", proto3);
_define_property(ComplianceResponseLocation, "typeName", "mono.datagateway.v1.ComplianceResponseLocation");
_define_property(ComplianceResponseLocation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "accountable_user_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "draft_complete",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "evidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ComplianceCoverageItem
 */ export class ComplianceCoverageItem extends Message {
    static fromBinary(bytes, options) {
        return new ComplianceCoverageItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ComplianceCoverageItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ComplianceCoverageItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ComplianceCoverageItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string version_id = 1;
   */ _define_property(this, "versionId", ""), /**
   * @generated from field: string requirement_id = 2;
   */ _define_property(this, "requirementId", ""), /**
   * Snapshot of the existing Pangaea ProposalRequirement model. Includes text,
   * mandatory flag, source provenance/constraints; excludes workflow status.
   *
   * @generated from field: string requirement_json = 3;
   */ _define_property(this, "requirementJson", ""), /**
   * @generated from field: repeated mono.datagateway.v1.ComplianceResponseLocation locations = 4;
   */ _define_property(this, "locations", []), /**
   * @generated from field: int64 revision = 5;
   */ _define_property(this, "revision", protoInt64.zero), /**
   * unaddressed, partial, addressed. Never inferred from mapping or drafting.
   *
   * @generated from field: string substantive_state = 6;
   */ _define_property(this, "substantiveState", ""), /**
   * @generated from field: string confirmed_by = 7;
   */ _define_property(this, "confirmedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp confirmed_at = 8;
   */ _define_property(this, "confirmedAt", void 0), /**
   * @generated from field: string evidence = 9;
   */ _define_property(this, "evidence", ""), /**
   * Removed requirements and every item on a historical version.
   *
   * @generated from field: bool superseded = 10;
   */ _define_property(this, "superseded", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ComplianceCoverageItem, "runtime", proto3);
_define_property(ComplianceCoverageItem, "typeName", "mono.datagateway.v1.ComplianceCoverageItem");
_define_property(ComplianceCoverageItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "requirement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "requirement_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "locations",
            kind: "message",
            T: ComplianceResponseLocation,
            repeated: true
        },
        {
            no: 5,
            name: "revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 6,
            name: "substantive_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "confirmed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "confirmed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "evidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "superseded",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ComplianceConfirmation
 */ export class ComplianceConfirmation extends Message {
    static fromBinary(bytes, options) {
        return new ComplianceConfirmation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ComplianceConfirmation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ComplianceConfirmation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ComplianceConfirmation, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string version_id = 2;
   */ _define_property(this, "versionId", ""), /**
   * @generated from field: string requirement_id = 3;
   */ _define_property(this, "requirementId", ""), /**
   * @generated from field: int64 revision = 4;
   */ _define_property(this, "revision", protoInt64.zero), /**
   * @generated from field: string substantive_state = 5;
   */ _define_property(this, "substantiveState", ""), /**
   * @generated from field: string actor = 6;
   */ _define_property(this, "actor", ""), /**
   * @generated from field: google.protobuf.Timestamp confirmed_at = 7;
   */ _define_property(this, "confirmedAt", void 0), /**
   * @generated from field: string evidence = 8;
   */ _define_property(this, "evidence", ""), /**
   * @generated from field: string requirement_json = 9;
   */ _define_property(this, "requirementJson", ""), /**
   * @generated from field: string locations_json = 10;
   */ _define_property(this, "locationsJson", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ComplianceConfirmation, "runtime", proto3);
_define_property(ComplianceConfirmation, "typeName", "mono.datagateway.v1.ComplianceConfirmation");
_define_property(ComplianceConfirmation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "requirement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 5,
            name: "substantive_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "confirmed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "evidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "requirement_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "locations_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ReadComplianceCoverageRequest
 */ export class ReadComplianceCoverageRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReadComplianceCoverageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReadComplianceCoverageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReadComplianceCoverageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReadComplianceCoverageRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReadComplianceCoverageRequest, "runtime", proto3);
_define_property(ReadComplianceCoverageRequest, "typeName", "mono.datagateway.v1.ReadComplianceCoverageRequest");
_define_property(ReadComplianceCoverageRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ReadComplianceCoverageResponse
 */ export class ReadComplianceCoverageResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReadComplianceCoverageResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReadComplianceCoverageResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReadComplianceCoverageResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReadComplianceCoverageResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string current_version_id = 1;
   */ _define_property(this, "currentVersionId", ""), /**
   * @generated from field: repeated mono.datagateway.v1.ComplianceCoverageItem items = 2;
   */ _define_property(this, "items", []), /**
   * @generated from field: repeated mono.datagateway.v1.ComplianceConfirmation confirmations = 3;
   */ _define_property(this, "confirmations", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReadComplianceCoverageResponse, "runtime", proto3);
_define_property(ReadComplianceCoverageResponse, "typeName", "mono.datagateway.v1.ReadComplianceCoverageResponse");
_define_property(ReadComplianceCoverageResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "current_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "items",
            kind: "message",
            T: ComplianceCoverageItem,
            repeated: true
        },
        {
            no: 3,
            name: "confirmations",
            kind: "message",
            T: ComplianceConfirmation,
            repeated: true
        }
    ]));
/**
 * Replaces mappings only; always clears substantive confirmation. Both expected
 * version and revision must match the current basis, including for retries.
 *
 * @generated from message mono.datagateway.v1.MapComplianceCoverageRequest
 */ export class MapComplianceCoverageRequest extends Message {
    static fromBinary(bytes, options) {
        return new MapComplianceCoverageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MapComplianceCoverageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MapComplianceCoverageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MapComplianceCoverageRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string version_id = 3;
   */ _define_property(this, "versionId", ""), /**
   * @generated from field: string requirement_id = 4;
   */ _define_property(this, "requirementId", ""), /**
   * @generated from field: int64 expected_revision = 5;
   */ _define_property(this, "expectedRevision", protoInt64.zero), /**
   * @generated from field: repeated mono.datagateway.v1.ComplianceResponseLocation locations = 6;
   */ _define_property(this, "locations", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MapComplianceCoverageRequest, "runtime", proto3);
_define_property(MapComplianceCoverageRequest, "typeName", "mono.datagateway.v1.MapComplianceCoverageRequest");
_define_property(MapComplianceCoverageRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "requirement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "expected_revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 6,
            name: "locations",
            kind: "message",
            T: ComplianceResponseLocation,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.MapComplianceCoverageResponse
 */ export class MapComplianceCoverageResponse extends Message {
    static fromBinary(bytes, options) {
        return new MapComplianceCoverageResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MapComplianceCoverageResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MapComplianceCoverageResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MapComplianceCoverageResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ComplianceCoverageItem item = 1;
   */ _define_property(this, "item", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MapComplianceCoverageResponse, "runtime", proto3);
_define_property(MapComplianceCoverageResponse, "typeName", "mono.datagateway.v1.MapComplianceCoverageResponse");
_define_property(MapComplianceCoverageResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item",
            kind: "message",
            T: ComplianceCoverageItem
        }
    ]));
/**
 * Explicit human action. Actor and timestamp are derived on the server.
 *
 * @generated from message mono.datagateway.v1.ConfirmComplianceCoverageRequest
 */ export class ConfirmComplianceCoverageRequest extends Message {
    static fromBinary(bytes, options) {
        return new ConfirmComplianceCoverageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConfirmComplianceCoverageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConfirmComplianceCoverageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConfirmComplianceCoverageRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string version_id = 3;
   */ _define_property(this, "versionId", ""), /**
   * @generated from field: string requirement_id = 4;
   */ _define_property(this, "requirementId", ""), /**
   * @generated from field: int64 expected_revision = 5;
   */ _define_property(this, "expectedRevision", protoInt64.zero), /**
   * @generated from field: string substantive_state = 6;
   */ _define_property(this, "substantiveState", ""), /**
   * @generated from field: string evidence = 7;
   */ _define_property(this, "evidence", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ConfirmComplianceCoverageRequest, "runtime", proto3);
_define_property(ConfirmComplianceCoverageRequest, "typeName", "mono.datagateway.v1.ConfirmComplianceCoverageRequest");
_define_property(ConfirmComplianceCoverageRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "requirement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "expected_revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 6,
            name: "substantive_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "evidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ConfirmComplianceCoverageResponse
 */ export class ConfirmComplianceCoverageResponse extends Message {
    static fromBinary(bytes, options) {
        return new ConfirmComplianceCoverageResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConfirmComplianceCoverageResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConfirmComplianceCoverageResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConfirmComplianceCoverageResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ComplianceCoverageItem item = 1;
   */ _define_property(this, "item", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ConfirmComplianceCoverageResponse, "runtime", proto3);
_define_property(ConfirmComplianceCoverageResponse, "typeName", "mono.datagateway.v1.ConfirmComplianceCoverageResponse");
_define_property(ConfirmComplianceCoverageResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item",
            kind: "message",
            T: ComplianceCoverageItem
        }
    ]));
